'use client';

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { PulseTextArea } from 'src/components';

interface ControlledJoyTextareaProps {
  name: string;
  rules?: any;
  autoFocus?: boolean;
  minRows?: number;
  maxRows?: number;
  helperText?: string;
  showLabel?: boolean;
  hasTooltip?: boolean;
  tooltipText?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const ControlledJoyTextarea = ({ ...props }: ControlledJoyTextareaProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  if (!props) return null;

  const errorMessage = props?.helperText || 'This field is required';
  const required = props.required || props.rules?.required;

  return (
    <Controller
      name={props.name}
      control={control}
      rules={{
        required: required ? errorMessage : false,
        ...props.rules,
      }}
      render={({ field }) => {
        return (
          <div className="flex flex-col gap-1">
            <PulseTextArea
              {...field}
              value={field.value || ''}
              onChange={field.onChange}
              error={!!errors[props.name]}
              minRows={props.minRows || 1}
              placeholder={props.placeholder}
              disabled={props.disabled}
              autoFocus={props.autoFocus}
              className={props.className}
            />
            {!!errors[props.name] && (
              <span className="text-xs text-red-500 ml-0">
                {errors[props.name]?.message as string}
              </span>
            )}
          </div>
        );
      }}
    />
  );
};

export default ControlledJoyTextarea;
